import React from 'react'
import './modal.css'

export const CalendlyModal = ({ closeModal, isOpen }) => {
    console.log(isOpen)
    return (
        <section className="modal_wrapper" onClick={closeModal}>
            <div className='modal_wrapper-contents'>
                <iframe title="Book talentpoel with calendly"
                    src='https://calendly.com/introcalltalentpoel/30min'
                    width="100%"
                    height="100%" className='calendly_flex'>

                </iframe>
            </div>
            {/* close button */}
            <button type='button' className='calender_close_btn' onClick={closeModal}>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0 0 24 24">
                    <path d="M 4.9902344 3.9902344 A 1.0001 1.0001 0 0 0 4.2929688 5.7070312 L 10.585938 12 L 4.2929688 18.292969 A 1.0001 1.0001 0 1 0 5.7070312 19.707031 L 12 13.414062 L 18.292969 19.707031 A 1.0001 1.0001 0 1 0 19.707031 18.292969 L 13.414062 12 L 19.707031 5.7070312 A 1.0001 1.0001 0 0 0 18.980469 3.9902344 A 1.0001 1.0001 0 0 0 18.292969 4.2929688 L 12 10.585938 L 5.7070312 4.2929688 A 1.0001 1.0001 0 0 0 4.9902344 3.9902344 z"></path>
                </svg>
            </button>
        </section>
    )
}
